import React from 'react'
import {Flex, FlexItem} from 'react-weui'


class TabBar extends React.Component {
    render() {
        const {tab} = this.props
        return(
            <div className="my-wk-tabbar">
                <Flex style={{fontSize: '14px'}}>
                    <FlexItem className={`my-wk-tabbar__item my-wk-tabbar__item-left ${tab === 1 ? "my-wk-tabbar__item-active" : ""}`} onClick={e => this.props.clickHandle(1)}>
                        <span>最近学习</span>
                    </FlexItem>
                    <FlexItem className={`my-wk-tabbar__item my-wk-tabbar__item-middle ${tab === 2 ? "my-wk-tabbar__item-active" : ""}`} onClick={e => this.props.clickHandle(2)}>
                        <span>最近讲课</span>
                    </FlexItem>
                    <FlexItem className={`my-wk-tabbar__item my-wk-tabbar__item-right ${tab === 3 ? "my-wk-tabbar__item-active" : ""}`} onClick={e => this.props.clickHandle(3)}>
                        <span>我买的课</span>
                    </FlexItem>
                </Flex>
            </div>
        )
    }
}

export default TabBar


// WEBPACK FOOTER //
// ./src/pages/mywkPage/TabBar.js